import React from "react";
import './style.scss';


const Footer = (props) =>{

    return(
        <div className="footer">
            all © rights reserved 
        </div>
    );
};

export default Footer;